/** Zod validation schemas for Preferences endpoints */

import { z } from 'zod'

export const updatePreferenceSchema = z.object({
  value: z.string().max(10000),
})
